export type Mode = "light" | "dark" | "system";
export type ResolvedMode = "light" | "dark";

export type SkinTokens = {
  background: string;
  foreground: string;
  border: string;
  input: string;
  ring: string;

  card: string;
  "card-foreground": string;
  "card-border": string;

  popover: string;
  "popover-foreground": string;
  "popover-border": string;

  primary: string;
  "primary-foreground": string;
  "primary-border": string;

  secondary: string;
  "secondary-foreground": string;
  "secondary-border": string;

  muted: string;
  "muted-foreground": string;
  "muted-border": string;

  accent: string;
  "accent-foreground": string;
  "accent-border": string;

  destructive: string;
  "destructive-foreground": string;
  "destructive-border": string;

  sidebar: string;
  "sidebar-foreground": string;
  "sidebar-border": string;
  "sidebar-primary": string;
  "sidebar-primary-foreground": string;
  "sidebar-primary-border": string;
  "sidebar-accent": string;
  "sidebar-accent-foreground": string;
  "sidebar-accent-border": string;
  "sidebar-ring": string;
};

export type Skin = {
  id: string;
  label: string;
  description: string;
  /** Small swatches for the gallery card preview: [bg, sidebar, accent, text]. */
  preview: { bg: string; sidebar: string; accent: string; text: string };
  /** Default accent id this skin pairs with (overridable). */
  defaultAccent: string;
  light: SkinTokens;
  dark: SkinTokens;
};

export type Accent = {
  id: string;
  label: string;
  /** HSL triplet without the hsl() wrapper, e.g. "187 65% 42%". */
  hsl: string;
  foregroundHsl: string;
  borderHsl: string;
};

export type FontPairing = {
  id: string;
  label: string;
  sample: string;
  body: string;
  heading: string;
  /** Google Fonts URL (loaded on demand). */
  googleFontsUrl?: string;
};

export type Pattern = {
  id: string;
  label: string;
  /** SVG data URL applied as background-image. Empty string = no pattern. */
  url: string;
};

export type AppearancePrefs = {
  skin: string;
  mode: Mode;
  accent: string;
  fontPairing: string;
  pattern: string;
};

export const DEFAULT_APPEARANCE: AppearancePrefs = {
  skin: "classic-teal",
  mode: "light",
  accent: "teal",
  fontPairing: "inter",
  pattern: "none",
};
